<template>
    <div id="location" class="mb-5" v-if="activities">
        <h3 class="display-3 mb-4">{{ activities.length }} popular things to do nearby</h3>
        <carousel :perPageCustom="[[0, 1], [768, 3], [1024, 4]]" :autoplay="true" :autoplayHoverPause="true" :paginationEnabled="false">
            <slide xs="4" v-for="activity in activities" :key="activity.id" class="m-2 align-self-stretch">
                <b-card no-body class="h-100">
                    <template v-if="activity.pictures">
                        <b-card-img top :src="activity.pictures[0]" />
                    </template>
                    <b-card-body>
                        <h3 class="display-4">
                            <a :href="activity.bookingLink" target="_blank">
                                {{ activity.name }}
                            </a>
                        </h3>
                        <!-- {{ activity.rating }} -->
                        <div class="price">
                            <ActivityPrice :activity="activity" />
                        </div>
                        <a class="btn btn-primary" :href="activity.bookingLink" target="_blank">
                            View details
                        </a>
                    </b-card-body>
                </b-card>
            </slide>
        </carousel>
    </div>
</template>

<script>
    import axios from "axios"
    import ActivityPrice from '@/components/ui/ActivityPrice'
    import { Carousel, Slide } from 'vue-carousel'

    export default {
        name: 'FeaturedActivities',
        components: {
            ActivityPrice,
            Carousel,
            Slide,
        },
        props: {
            result: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                activities: []
            }
        },
        methods: {
            loadResults() {
                axios
                    .get('https://api.stay.com.de/?action=activities-near' +
                        '&lat=' + this.result.hotel.latitude + 
                        '&lng=' + this.result.hotel.longitude
                    )
                    .then(response => {
                        this.activities = response.data.data;
                    })
                ;
            }
        },
        mounted () {
            this.loadResults();
        }
    }
</script>

<style scoped>
    .gallery-location{
        height: 100% !important;
        width: 100% !important;
        min-height: 150px;
    }

    .gallery,
    .gallery-location{
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }
</style>